/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @typescript-eslint/restrict-plus-operands */
import React, {
    Dispatch,
    SetStateAction,
    memo,
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import { MediaSettingsContext, SettingsContext } from "../../DMSMedia";
import DummyCard from "./DummyCard";
import { AntmediaContext } from "../../../../App";
import LeftIcon from "@ht/shared/fonts/deos-pis/arrow-left";

import clsx from "clsx";
import "./style.css";
import MicMute from "@ht/shared/fonts/deos-pis/mic-mute";
import TalkIcon from "@ht/shared/fonts/deos-pis/radio";
interface IProps {
    srcObject?: any;
    hidePin?: boolean;
    onHandlePin(): void;
    id: string;
    track?: any;
    autoPlay: boolean;
    pinned?: boolean;
    name?: string;
    muted?: boolean;
    style?: any;
    hideTalkingIndicator?: boolean;
}
const onTrackEnded = (
    participants: any[],
    settings: any,
    callBack: (oldParts: any) => any[],
    props: any
) => {
    if (participants.length > settings?.globals?.maxVideoTrackCount) {
        callBack((oldParts: any) => {
            return oldParts.filter(
                (p: any) => !(p.id === props.id || p.videoLabel === props.id)
            );
        });
    }
};
const enableAudioLevelLocalStream = (
    value: number,
    isTalking: any,
    setIsTalking: Dispatch<SetStateAction<boolean>>,
    timeoutRef: any,
    antmedia: any,
    mediaSettings: any
) => {
    if (value >= 0.01) {
        if (isTalking === false) setIsTalking(true);
        clearInterval(timeoutRef.current as NodeJS.Timeout);
        timeoutRef.current = setTimeout(() => {
            setIsTalking(false);
        }, 800);
        antmedia.updateAudioLevel(
            mediaSettings?.myLocalData?.streamId,
            Math.floor(value * 100)
        );
    }
};
const settingIsTalking = (
    mediaSettings: any,
    props: any,
    setIsThisTalking: Dispatch<SetStateAction<boolean>>
) => {
    if (props.id !== "localVideo") {
        const currentTalker = mediaSettings.talkers.filter(
            (x: any) => x.trackId === props.id
        );
        if (currentTalker.length > 0) {
            setIsThisTalking(currentTalker[0].audioLevel > 0);
        } else {
            setIsThisTalking(false);
        }
    }
}
const mediaSettingChanged = (mediaSettings: any, props: any) => {
    let isOff = mediaSettings?.cam?.find(
        (c: any) => c.eventStreamId === props?.id
    );
    if (isOff) isOff = !isOff?.isCameraOn;
    //?? true;
    else isOff = true;

    console.log("ISOFF 1", isOff, mediaSettings.cam);
    // if i sharing my screen.
    if (
        mediaSettings.isScreenShared === true &&
        props?.id === "localVideo" &&
        mediaSettings?.cam.find(
            (c: any) =>
                c.eventStreamId === "localVideo" &&
                c.isCameraOn === false
        )
    ) {
        isOff = true;
    }
    console.log("ISOFF 3", isOff, mediaSettings.cam);

    // screenSharedVideoId is the id of the screen share video.
    if (
        mediaSettings.screenSharedVideoId === props?.id &&
        mediaSettings?.cam.find(
            (c: any) =>
                c.eventStreamId === props?.id && c.isCameraOn === false
        )
    ) {
        isOff = true;
    }
    console.log("ISOFF FINAL", isOff, mediaSettings.cam);
    return isOff;
}
const VideoCard = memo(
    ({
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        srcObject,
        hidePin,
        onHandlePin,
        hideTalkingIndicator,
        pinned,
        name,
        ...props
    }: IProps) => {
        const timeoutRef: { current: NodeJS.Timeout | null } = useRef(null);
        const mediaSettings = useContext(MediaSettingsContext);
        const settings = useContext(SettingsContext);
        const antmedia = useContext(AntmediaContext);
        const [displayHover, setDisplayHover] = React.useState(false);
        const { setParticipants, participants } = mediaSettings;
        const [isVideoOff, setIsVideoOff] = useState(false);
        const [isTalking, setIsTalking] = React.useState(false);
        const [isThisTalking, setIsThisTalking] = useState(false);

        const refVideo = useCallback(
            (node) => {
                if (node && props.track) {
                    node.srcObject = new MediaStream([props.track]);
                }
            },
            [props.track]
        );

        React.useEffect(() => {
            if (props.track?.kind === "video" && !props.track.onended) {
                props.track.onended = () => {
                    onTrackEnded(
                        participants,
                        settings,
                        setParticipants,
                        props
                    );
                };
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [props.track]);

        useEffect(() => {
            const isOffResult = mediaSettingChanged(mediaSettings, props)
            setIsVideoOff(isOffResult);

        }, [mediaSettings.cam]);
        const mic = mediaSettings?.mic?.find(
            (m: any) => m.eventStreamId === props?.id
        );

        const isLocal = props?.id === "localVideo";
        const mirrorView = isLocal && !mediaSettings?.isScreenShared;

        useEffect(() => {
            if (isLocal && mediaSettings.isPublished) {
                antmedia.enableAudioLevelForLocalStream((value: number) => {
                    // sounds under 0.01 are probably background noise
                    enableAudioLevelLocalStream(
                        value,
                        isTalking,
                        setIsTalking,
                        timeoutRef,
                        antmedia,
                        mediaSettings
                    );
                }, 800);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [mediaSettings.isPublished]);

        useEffect(() => {

            settingIsTalking(mediaSettings, props, setIsThisTalking);

        }, [mediaSettings.talkers]);
        return isLocal || props.track?.kind !== "audio" ? (
            <>
                <div
                    role={"button"}
                    tabIndex={0}
                    className="w-[100%] h-[100%] relative"
                    onMouseEnter={() => setDisplayHover(true)}
                    onMouseLeave={() => setDisplayHover(false)}
                >
                    {!hidePin && (
                        <div
                            className={clsx(
                                "flex flex-col justify-center items-center p-[8px] rounded-lg h-[100%] absolute left-0 top-0 z-[98] transition-opacity",
                                {
                                    "opacity-100": displayHover,
                                    "opacity-0": !displayHover,
                                }
                            )}
                        >
                            <div
                                role={"button"}
                                tabIndex={-1}
                                onKeyDown={onHandlePin}
                                onClick={onHandlePin}
                                color="primary"
                                aria-label="add"
                            >
                                {!pinned && (
                                    <div className="w-[36px] h-[36px] p-[2px] bg-white rounded-full opacity-[0.5]">
                                        <LeftIcon className="w-[32px] h-[32px] text-black"></LeftIcon>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    <div className={`single-video-card h-[100%]`}>
                        <div
                            className={clsx(
                                "draggable h-[100%] bg-gray-200 rounded-lg",
                                { hidden: !isVideoOff }
                            )}
                        >
                            <DummyCard name={name ?? ""} />
                        </div>

                        <div
                            className={clsx("h-[100%] bg-transparent", {
                                mirror: mirrorView,
                                hidden: isVideoOff,
                            })}
                        >
                            <video
                                className={clsx(
                                    "draggable w-[100%] h-[100%] center",
                                    {
                                        "object-contain":
                                            mediaSettings?.screenSharedVideoId ===
                                            props?.id,
                                        "object-cover":
                                            mediaSettings?.screenSharedVideoId !==
                                            props?.id,
                                    },
                                    { "rounded-lg": !pinned }
                                )}
                                {...props}
                                ref={refVideo}
                                playsInline
                            >
                                <track
                                    src="captions_en.vtt"
                                    kind="captions"
                                    srcLang="en"
                                    label="english_captions"
                                ></track>
                            </video>
                        </div>

                        <div
                            className={clsx(
                                "flex flex-row-reverse absolute z-[999] p-[12px] top-[2px] left-[2px]"
                            )}
                        >
                            {mic?.isMicMuted ? (
                                <div
                                    className={clsx(
                                        "flex flex-col items-center justify-center rounded-lg bg-white w-[20px] h-[20px]"
                                    )}
                                >
                                    <MicMute
                                        className={clsx(
                                            "text-primary w-[16px] h-[16px]"
                                        )}
                                    />
                                </div>
                            ) : (
                                <div
                                    className={clsx(
                                        "talking-indicator-light",
                                        { hidden: !(isTalking || isThisTalking) },
                                        { hidden: hideTalkingIndicator }
                                    )}
                                >
                                    <div
                                        className={clsx(
                                            "flex flex-col items-center justify-center rounded-lg bg-white w-[20px] h-[20px]"
                                        )}
                                    >
                                        <TalkIcon
                                            className={clsx(
                                                "text-primary w-[18px] h-[18px]"
                                            )}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </>
        ) : (
            <>
                <video className="hidden" {...props} ref={refVideo} playsInline>
                    <track
                        src="captions_en.vtt"
                        kind="captions"
                        srcLang="en"
                        label="english_captions"
                    ></track>
                </video>
            </>
        );
    }
);
VideoCard.displayName = "Video Card";
export default VideoCard;
